import { render, staticRenderFns } from "./sceButton.vue?vue&type=template&id=2a234ae5"
import script from "./sceButton.vue?vue&type=script&lang=js"
export * from "./sceButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports